import ApiService from './Api.service.js'

class EventService extends ApiService {
  getEvents(institutionId, userId, roleId) {
    return this.resource.get(`institutions/${institutionId}/roles/${roleId}/users/${userId}/meetings`)
  }
  getModuleEvents(userId, roleId, moduleId) {
    return this.resource.get(`roles/${roleId}/users/${userId}/modules/${moduleId}/meetings`)
  }
  getUnitEvents(userId, unitId) {
    return this.resource.get(`users/${userId}/units/${unitId}/meetings`)
  }
}

export default new EventService('events')



// WEBPACK FOOTER //
// ./src/services/axios/event.service.js